import React from 'react'
import { Layout } from 'antd'
import '../App.css'

import Header from './header'
import Profile from './profile'
import Race from './race'
import Vr from './vr'
import Footer from './footer'

const { Content } = Layout

function home() {
  return (
    <Layout className="layout">
      <Header />
      <Content>
        <Profile />
        <Race />
        <Vr />
      </Content>
      <Footer />
    </Layout>
  )
}

export default home



// WEBPACK FOOTER //
// ./src/components/Home.js